import { Controller } from "@hotwired/stimulus"

// Muestra un overlay animado mientras la IA (Gemini) lee la factura.
// Connect via: data-controller="invoice-extraction-progress"
// El form debe tener: data-action="submit->invoice-extraction-progress#show"
export default class extends Controller {
  static targets = ["overlay", "message", "submessage", "step"]

  static phases = [
    { main: "Subiendo PDF…",                          sub: "Estamos enviando el archivo a nuestro servidor.",          step: 1 },
    { main: "La IA está leyendo la factura…",         sub: "Identificando proveedor, CUIT, fecha y comprobante.",      step: 2 },
    { main: "Extrayendo items y precios…",            sub: "Cantidades, precios unitarios, alícuotas y subtotales.",   step: 3 },
    { main: "Calculando totales y percepciones…",     sub: "Confirmando neto gravado, IVA y percepciones.",            step: 4 },
    { main: "Casi listo…",                            sub: "Preparando la pantalla de validación.",                    step: 5 }
  ]

  show(event) {
    // Mostramos el overlay y arrancamos la rotación de mensajes.
    this.overlayTarget.classList.remove("d-none")
    this.phaseIndex = 0
    this.render()
    // Rotamos cada 2.5s. Si la respuesta llega antes, la página redirige y descarta el timer.
    this.intervalId = window.setInterval(() => {
      this.phaseIndex = Math.min(this.phaseIndex + 1, this.constructor.phases.length - 1)
      this.render()
    }, 2500)
  }

  render() {
    const phase = this.constructor.phases[this.phaseIndex]
    this.messageTarget.textContent = phase.main
    this.submessageTarget.textContent = phase.sub
    if (this.hasStepTarget) {
      this.stepTarget.textContent = `Paso ${phase.step} de ${this.constructor.phases.length}`
    }
  }

  disconnect() {
    if (this.intervalId) window.clearInterval(this.intervalId)
  }
}
